import { FlowChain } from "./FlowChain";

const BEFORE = ["12-place class", "Large spreadsheet", "Repeated parent emails", "Knowledge concentrated in Alison"];
const CHANGE = ["Authoritative web information", "Routine questions answered once", "Predictable communications automated", "Exceptions reach a person"];

export const AlisonMiniJourney = () => (
  <div className="alison-mini" data-testid="alison-mini-journey">
    <div className="alison-mini-cols">
      <div className="alison-mini-col before" data-testid="alison-mini-before">
        <div className="alison-mini-col-title">Before</div>
        <ol>
          {BEFORE.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ol>
      </div>
      <span className="alison-mini-arrow" aria-hidden="true">{"\u2192"}</span>
      <div className="alison-mini-col change" data-testid="alison-mini-change">
        <div className="alison-mini-col-title">Change</div>
        <ol>
          {CHANGE.map((c) => (
            <li key={c}>{c}</li>
          ))}
        </ol>
      </div>
    </div>
    <div className="alison-mini-test">
      <div className="alison-mini-test-title">The Number 2 Test</div>
      <FlowChain steps={["Login", "Understand", "See exceptions", "Act", "Continue"]} testId="alison-mini-flowchain" />
    </div>
  </div>
);
